import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { localStorageKeys } from '../../../Models/configurations';
import { SecureStorageService } from './../../../Services/secure-storage.service';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
export class MapComponent implements OnInit, AfterViewInit {

  @ViewChild('mapPopup') content;
  latitude: number;
  longitude: number;
  zoom: number = 15; // Default zoom level
  styles: any;
  scaleControlOptions:any;
  dealerData: any;
  customerData: any;
  dealerDestination: google.maps.LatLngLiteral;
  customerStartup: google.maps.LatLngLiteral;
  isOwner: boolean = false;
  closeResult: string;
  errorMessage: string = "";
  isMap : boolean =false;

  public renderOptions = {
    suppressMarkers: true,
  };

  public markerOptions = {
    origin: {
      icon: 'https://www.google.com/intl/en_us/mapfiles/ms/micons/blue-dot.png',
      // label: (this.secureStorageService.getKeyData(localStorageKeys.checkingModule)).CustomerDetail.CustomerName,
      draggable: false,
    },
    destination: {
      icon: 'https://www.google.com/intl/en_us/mapfiles/ms/micons/red-dot.png',
      // label: (this.secureStorageService.getKeyData(localStorageKeys.checkingModule)).DealerDetail.DealerName,
      draggable: false,
    },
  };

  private modalRef: NgbModalRef;

  constructor(
    private modalService: NgbModal,
    private readonly secureStorageService: SecureStorageService,
  ) {}

  locationPin(data: any, type: string) {
    if (type === 'getDealerDetails') {
      this.dealerData = data;
    }
    else if (type === 'getCustomerDetails') {
      this.customerData = data;
    }

    if (this.customerData?.status === 'OK' && this.dealerData?.status === 'OK') {
      this.dealerDestination = this.dealerData.results[0].geometry.location;
      this.customerStartup = this.customerData.results[0].geometry.location;
    } 
    else if (this.customerData?.status === 'ZERO_RESULTS' || this.dealerData?.status === 'ZERO_RESULTS') {
      if (this.customerData.status === 'ZERO_RESULTS') {
        this.errorMessage = "Customer's address is incorrect.";
      }
      if (this.dealerData.status === 'ZERO_RESULTS') {
        this.errorMessage += " Dealer's address is incorrect.";
      }
      this.modalRef = this.modalService.open(this.content, { ariaLabelledBy: 'modal-basic-title' });
      this.modalRef.result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  private getDealerLocationBaseOnPinCode(): any {
    fetch(EnvSetting.googleMapUrl + '?address=' +
      (this.secureStorageService.getKeyData(localStorageKeys.checkingModule)).dealerDetail.addressLine1?.trim() + ',' +
      (this.secureStorageService.getKeyData(localStorageKeys.checkingModule)).dealerDetail.addressLine2?.trim() + ',' +
      (this.secureStorageService.getKeyData(localStorageKeys.checkingModule)).dealerDetail.city.trim() + ',' +
      (this.secureStorageService.getKeyData(localStorageKeys.checkingModule)).dealerDetail.country.trim() + ',' +
      (this.secureStorageService.getKeyData(localStorageKeys.checkingModule)).dealerDetail.pinCode.trim() +
      '&key=' + EnvSetting.googleKey)
      .then(response => response.json())
      .then(data => {
        this.locationPin(data, "getDealerDetails");
      }, _error => {
        // This is intentional
      });
  }

  private getCustomerLocationBaseOnPinCode(): any {
    fetch(EnvSetting.googleMapUrl + '?address=' +
      (this.secureStorageService.getKeyData(localStorageKeys.checkingModule)).customerDetail.addressLine1?.trim() + ',' +
      (this.secureStorageService.getKeyData(localStorageKeys.checkingModule)).customerDetail.addressLine2?.trim() + ',' +
      (this.secureStorageService.getKeyData(localStorageKeys.checkingModule)).customerDetail.city.trim() + ',' +
      (this.secureStorageService.getKeyData(localStorageKeys.checkingModule)).customerDetail.country.trim() + ',' +
      (this.secureStorageService.getKeyData(localStorageKeys.checkingModule)).customerDetail.pinCode.trim() +
      '&key=' + EnvSetting.googleKey)
      .then(response => response.json())
      .then(data => {
        this.locationPin(data, "getCustomerDetails");
      }, _error => {
        // This is intentional
      });
  }

  ngOnInit(): void {
    if (!window.google || !window.google.maps) {
      this.loadGoogleMapsScript();
    }
    this.loadGoogleMapsScript();
    const checkingModuleData = this.secureStorageService.getKeyData(localStorageKeys.checkingModule);
    this.isOwner = checkingModuleData.isOwner;

    if (this.isOwner) {
      this.getDirection();
    } else {
      this.latitude = checkingModuleData.dealerDetail.latitude;
      this.longitude = checkingModuleData.dealerDetail.longitude;
    }
  }

  getDirection(): void {
    const checkingModuleData = this.secureStorageService.getKeyData(localStorageKeys.checkingModule);
    this.customerStartup = { 
      lat: checkingModuleData.customerDetail.customerLatitude, 
      lng: checkingModuleData.customerDetail.customerLongitude 
    };
    this.dealerDestination = { 
      lat: checkingModuleData.dealerDetail.latitude, 
      lng: checkingModuleData.dealerDetail.longitude 
    };
  }

  ngAfterViewInit(): void {
    // This is intentional
  }
  

  loadGoogleMapsScript() {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${EnvSetting.googleKey}`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }
}
